import React, { Component } from 'react';

import './Modal.css';
import Close from '../Icons/Close.svg';
import Loader from '../Icons/Loader';

class ModalDeleteProject extends Component {

	constructor(props) {
	    super(props);
	    this.hideModal = this.hideModal.bind(this);
	}

	hideModal() {
		this.props.actions.hideModal();
	}

	validAction(){
		if(this.props.type === 'alertDeleteProject'){
			this.props.backFormValid();
			this.props.messageInfo();
			this.props.deleteProject();
		}
	}

  	render() {

			console.log(-this.props.userBackingAmount);
	    return (
			<div>
				<div className="modalBackground" onClick={() => this.hideModal()} ></div>
				<div className="modalContainer alert">
					<div className="modalBloc">
						<div className="close" onClick={() => this.hideModal()} ><img src={Close} alt="Close" /></div>
						<div className="content">
							<div className="title">Are you sure?</div>
							<div className="actions">
								<div className="button is-abort" onClick={() => this.hideModal()} >No, abort!</div>
								<button className="button is-primary" disabled={this.props.deleteProjectIsLoading} onClick={() => this.validAction()}>{this.props.deleteProjectIsLoading ? <Loader color="#fff" /> : 'Yes, do it!'}</button>
							</div>
						</div>
					</div>
				</div>
			</div>
	    );
  	}
}

export default ModalDeleteProject;



// WEBPACK FOOTER //
// ./src/components/Modal/ModalDeleteProject.js